module.exports = __webpack_public_path__ + "static/img/19b.bd0c2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/19b.jpg
// module id = Kcde
// module chunks = 0